import React from 'react'
import {
  HeadingText,
  BodyText,
  CaptionText,
  Container,
  Row,
  Col,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import * as styles from './intro.css'

export const PrivacyContent = () => {
  return (
    <Container data-testid="privacyContent" className={styles.privacyContainer}>
      <Row>
        <Col>
          <HeadingText
            as="h1"
            size="sm"
            type="strong"
            className={styles.privacyHeading}
          >
            <Message id="privacyStatement.title" />
          </HeadingText>
        </Col>
      </Row>
      <Row>
        <Col>
          <BodyText as="p" type="strong" className={styles.privacyHeading}>
            <Message id="privacyStatement.firstSection.title" />
          </BodyText>
        </Col>
      </Row>
      <Row>
        <Col>
          <CaptionText as="p">
            <Message id="privacyStatement.firstSection.subtitle1" />
          </CaptionText>
          <ul>
            <CaptionText as="li">
              <Message id="privacyStatement.firstSection.listItem1" />
            </CaptionText>

            <CaptionText as="li">
              <Message id="privacyStatement.firstSection.listItem2" />
            </CaptionText>
          </ul>
          <CaptionText as="p">
            <Message id="privacyStatement.firstSection.subtitle2" />
          </CaptionText>
          <ul>
            <CaptionText as="li">
              <Message id="privacyStatement.firstSection.listItem3" />
            </CaptionText>
            <CaptionText as="li">
              <Message id="privacyStatement.firstSection.listItem4" />
            </CaptionText>
          </ul>
        </Col>
      </Row>
      <Row>
        <Col>
          <BodyText as="p" type="strong" className={styles.privacyHeading}>
            <Message id="privacyStatement.secondSection.title" />
          </BodyText>
        </Col>
      </Row>
      <Row>
        <Col>
          <CaptionText as="p">
            <Message id="privacyStatement.secondSection.body1" />
          </CaptionText>
          <CaptionText as="p">
            <Message id="privacyStatement.secondSection.body2" />
          </CaptionText>
          <ul>
            <CaptionText as="li">
              <Message id="privacyStatement.secondSection.listItem1" />
            </CaptionText>
          </ul>
        </Col>
      </Row>
    </Container>
  )
}
